import {post, get} from "../http";
import {
  ENDPOINT_ADMIN_MASTER_MERCHANT_CREATE,
  ENDPOINT_ADMIN_MASTER_MERCHANT_STATUS
} from "../../constants/api";

export function apiAdminCreateMasterMerchant(params) {
  params = params || {};
  return post(
    ENDPOINT_ADMIN_MASTER_MERCHANT_CREATE,
    params,
    () => {
      return {response: 'SUCCESS'};
    }
  );
}
export function apiAdminCheckMasterMerchantAvailability(params) {
  params = params || {};
  return get(
    ENDPOINT_ADMIN_MASTER_MERCHANT_STATUS,
    params,
    () => {
      return {response: 'SUCCESS'};
    }
  );
}
